import { PersonaOpportunityTabPlaceholder } from "../PersonaOpportunityTabPlaceholder/PersonaOpportunityTabPlaceholder.js";

export interface SentToVendorTabPlaceholderProps {
  onGoToOpportunities?: () => void;
}

export function SentToVendorTabPlaceholder({
  onGoToOpportunities,
}: SentToVendorTabPlaceholderProps) {
  return (
    <div className="rounded-md border border-border">
      <PersonaOpportunityTabPlaceholder
        icon="file"
        titleKey="personaOpportunities.tabs.sentToVendorPlaceholderTitle"
        titleFallback="Nothing sent to vendor yet"
        descriptionKey="personaOpportunities.tabs.sentToVendorPlaceholderDescription"
        descriptionFallback="Approved scripts you send for production will land here."
        actionLabelKey="personaOpportunities.tabs.backToOpportunities"
        actionLabelFallback="Back to Opportunities"
        onAction={onGoToOpportunities}
      />
    </div>
  );
}
